import { definitions } from 'api/generated/ratings_v2.preferences'

export interface PhotoRatingSettingsState {
  form: Form & {
    currentLocationAutocomplete?: definitions['NamedLocation']
  }
  defaultForm: Form & {
    currentLocationAutocomplete?: definitions['NamedLocation']
  }
  formSaving: boolean
  settingsLoaded: boolean
  photoRatingSettingsFetchingFailed: boolean
  photoRatingSettingsFetchingServerError: boolean
}

const defaultForm = {
  ageFrom: 0,
  ageTo: 0,
  heightFrom: 0,
  heightTo: 0,
  coordinates: false as boolean | undefined,
  gender: '',
  country: 0,
  region: 0,
  city: 0,
  metro: 0,
  countryName: '',
  regionName: '',
  cityName: '',
  metroName: '',
}

export type Form = typeof defaultForm

export const initialState: PhotoRatingSettingsState = {
  form: { ...defaultForm },
  defaultForm: { ...defaultForm },
  formSaving: false,
  settingsLoaded: false,
  photoRatingSettingsFetchingFailed: false,
  photoRatingSettingsFetchingServerError: false,
}
